module.exports = __webpack_public_path__ + "img/Introducing-GBWhatsApp.34d03419.webp";